import axios from 'axios';

import JsonNullToSpace from './jsonNullToSpace';

class ApiCall {
  constructor() {
    let apiCall = axios.create({
      headers: {
        AJAX: true,
        csrf: 'token',
        Accept: 'application/json, text/plain, */*',
      }
    });
    apiCall.interceptors.response.use(this.handleSuccess, this.handleError);
    this.apiCall = apiCall;
  }

  handleSuccess(response) {
    JsonNullToSpace(response.data);
    return response;
  }

  handleError = error => {
    let err;

    try {
      err = error.response.data;
    } catch(e) {
      err = '에러가 발생하였습니다.';
    }

    switch (error.response.status) {
      case 401:
        this.redirectTo(document, '/login')
        break;

      case 404:
        this.redirectTo(document, '/404')
        break;

      case 500:
        if (typeof err === 'string') {
          err = { msg: err };

        } else if (!err) {
          err = { msg: '에러가 발생하였습니다.' };

        } else if (err.message) {
          err = { msg: err.message };

        } else {
          err = { msg: '에러가 발생하였습니다.' };
        }
        break;

      default:
        break;
    }
    return Promise.reject(err)
  }

  redirectTo = (document, path) => {
    document.location = path
  }

  get(path, params, callback) {
    return this.apiCall.request({
      method: 'GET',
      url: path,
      responseType: 'json',
      params: params
    }).then(response => {
      return Promise.resolve(response.data, response.status)
    });
  }

  post(path, payload, callback) {
    return this.apiCall.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    }).then(response => {
      return Promise.resolve(response.data, response.status)
    });
  }

  put(path, payload, callback) {
    return this.apiCall.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
    }).then(response => {
      return Promise.resolve(response.data, response.status)
    });
  }

  patch(path, payload, callback) {
    return this.apiCall.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    }).then(response => {
      return Promise.resolve(response.data, response.status)
    });
  }

  delete(path, params, callback) {
    return this.apiCall.delete(path, {
      params: params
    }).then(response => {
      return Promise.resolve(response.data, response.status)
    });
  }
}

export default new ApiCall();



// WEBPACK FOOTER //
// ./client/utils/apiCall.js